import { type TCoreCheckboxOptions, type TCoreInputData } from '@core/widgets';
import { useBehavior, useCheckBox } from '@libs/core';
import { TInputData, TWidget } from '@libs/types';
import React from 'react';
import { TCheckboxOption } from '../../types/options';
import { SwitcherView } from './SwitcherView';

type TSwitcherWidgetProps = {
    widget: TWidget<TInputData, TCheckboxOption>;
};

const SwitcherWidget = ({ widget }: TSwitcherWidgetProps) => {
    const data = widget.data ?? {};
    const options = widget.options ?? {};
    const label = data.messages?.label || data.label;

    const { isChecked, handleChange } = useCheckBox(widget, { skipValidation: true });
    const { isDisabled, isHidden } = useBehavior(widget);

    const parentStyleNames = [options.style].filter(Boolean) as string[];

    return (
        <SwitcherView
            uid={widget.uid}
            widget={widget as TWidget<TCoreInputData, TCoreCheckboxOptions>}
            label={label}
            isChecked={isChecked}
            handleChange={handleChange}
            isDisabled={isDisabled}
            isHide={isHidden}
            margin={options.margin}
            style={options.style}
            parentStyleNames={parentStyleNames}
            version={widget.version}
        />
    );
};

export { SwitcherWidget };
